export default __webpack_public_path__ + "static/media/no_page_found.4b9a2c01.png";